module.exports = __webpack_public_path__ + "img/0Q3A2365_P_L_Black.6e5d6a33.jpg";